import React, { Component, Fragment, useEffect } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import axios from "axios";
import cookie from "js-cookie";

import LogOutRoute from "./wrappers/LogOutRoute";
import ClientDashboardWrapperTemp from "./wrappers/ClientDashboardWrapperTemp";
import AdminDashboardWrapper from "./wrappers/AdminDashboardWrapper";
import LoginPage from "./pages/auth/LogInPage";
import { LoadingSpinnerComponent } from "./components/general/Spinner/PromiseSpinner";
import AOMLoginPage from "./pages/auth/AOMLoginPage";
import PrintOrderSheet from "./pages/admin/PrintOrderSheet";

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastProvider } from "./wrappers/ToastContext";

import { toast } from 'react-toastify';

const config = {
  headers: {
    "Content-Type": "application/json"
  },
  withCredentials: true
};

axios.interceptors.response.use(
  response => {
    return response
  },
  function (error) {
    if (error.response.status === 401 && !window.location.pathname.includes('/login')) {
      toast.error('Your session has expired. You will be automatically logged out in 5 seconds. Please log back in again to proceed with your activity.', {
        onClose: () => window.location.href = `${window.location.origin}/dashboard/login`
      })
    } else if (error?.response?.data?.message) {
      toast.error(error?.response?.data?.message)
      throw new Error(error)
    }
  }
)

const App = () => {
  return (
    <ToastProvider>
      <ToastContainer />
      <Switch>
        <Redirect from="/dashboard" to="/dashboard/login" exact/>
        <Route path="/dashboard/login" component={LoginPage} />
        <Route path="/dashboard/aom/login" component={AOMLoginPage} />
        <Route path="/dashboard/logout" component={LogOutRoute} />
        <Route path="/dashboard/admin" component={AdminDashboardWrapper} />
        <Route path="/dashboard/map/:inventory" component={ClientDashboardWrapperTemp} />
        <Route path="/dashboard" component={ClientDashboardWrapperTemp} />
        {/* <Route path="/dashboard/admin/print-order-sheet" component={PrintOrderSheet} /> */}
        {/* <Route path="/dashboard/map/:inventory" component={ClientDashboardWrapper} />
        <Route path="/dashboard" component={ClientDashboardWrapper} /> */}
        <Redirect from="/dashboard/*" to="/dashboard/map" />
        <Redirect from="*" to="/" />
      </Switch>
      <LoadingSpinnerComponent />
    </ToastProvider>

  );
}

export default App;
